import React, { Fragment, useContext } from "react";
import { useTranslation } from "react-i18next";
import { NavLink, useLocation } from "react-router-dom";
import CustomizerContext from "../../_helper/Customizer";
import { MENUITEMS } from "./Menu";

const SidebarMenuItems = ({
  setMainMenu,
  sidebartoogle,
  setNavActive,
  activeClass,
}) => {
  const { layout } = useContext(CustomizerContext);
  const layout1 = localStorage.getItem("sidebar_layout") || layout;
  const location = useLocation();
  const { t } = useTranslation();

  // Determine which portal we are in based on the current URL path
  // Adjust these checks to match your actual base paths (platformBasePath / companyBasePath)
  const isPlatform = location.pathname.includes("/platform");
  const isCompany = location.pathname.includes("/company");

  // Only show the section that matches the current portal.
  // Falls back to showing all sections if neither matches (shouldn't normally happen).
  const visibleSections = MENUITEMS.filter((section) => {
    if (isPlatform) return section.portalType === "platform";
    if (isCompany) return section.portalType === "company";
    return true; // fallback: show everything
  });

  const toggleNavActive = (item) => {
    // Close sidebar on mobile when a link is clicked
    if (window.innerWidth <= 991) {
      const pageHeader = document.querySelector(".page-header");
      const sidebarWrapper = document.querySelector(".sidebar-wrapper");
      if (pageHeader) pageHeader.className = "page-header close_icon";
      if (sidebarWrapper)
        sidebarWrapper.className = "sidebar-wrapper close_icon";
      if (item.type === "sub") {
        if (pageHeader) pageHeader.className = "page-header";
        if (sidebarWrapper) sidebarWrapper.className = "sidebar-wrapper";
      }
    }

    // Toggle active state; collapse siblings
    if (!item.active) {
      MENUITEMS.forEach((section) => {
        section.Items.forEach((menuItem) => {
          if (section.Items.includes(item)) menuItem.active = false;
          if (!menuItem.children) return;
          menuItem.children.forEach((child) => {
            if (menuItem.children.includes(item)) child.active = false;
            if (!child.children) return;
            child.children.forEach((grandchild) => {
              if (child.children.includes(item)) grandchild.active = false;
            });
          });
        });
      });
    }
    item.active = !item.active;
    setMainMenu({ mainmenu: MENUITEMS });
  };

  return (
    <>
      {visibleSections.map((section, sectionIdx) => (
        <Fragment key={sectionIdx}>
          {/* Section title */}
          {/* <li className="sidebar-main-title">
            <div>
              <h6 className="lan-1">{t(section.menutitle)}</h6>
              <p className="lan-2" style={{ color: "#000000" }}>
                {t(section.menucontent)}
              </p>
            </div>
          </li> */}

          {section.Items.map((menuItem, itemIdx) => {
            const IconComponent = menuItem.icon;
            const isItemActive =
              menuItem.active ||
              (menuItem.path &&
                location.pathname.startsWith(
                  menuItem.path.replace(process.env.PUBLIC_URL || "", ""),
                ));

            return (
              <li className="sidebar-list" key={itemIdx}>
                {/* ── Sub-menu parent ── */}
                {menuItem.type === "sub" && (
                  <a
                    href="#!"
                    className={`sidebar-link sidebar-title${isItemActive ? " active" : ""}`}
                    onClick={(e) => {
                      e.preventDefault();
                      setNavActive(menuItem);
                      activeClass(menuItem.active);
                    }}
                  >
                    {IconComponent && (
                      <IconComponent
                        size={18}
                        strokeWidth={1.75}
                        className="sidebar-feather-icon"
                        aria-hidden
                      />
                    )}
                    <span>{t(menuItem.title)}</span>
                    {menuItem.badge && (
                      <label className={menuItem.badge}>
                        {menuItem.badgetxt}
                      </label>
                    )}
                    <div className="according-menu">
                      <i
                        className={`fa fa-angle-${menuItem.active ? "down" : "right"}`}
                      />
                    </div>
                  </a>
                )}

                {/* ── Direct link ── */}
                {menuItem.type === "link" && (
                  <NavLink
                    to={menuItem.path}
                    className={({ isActive }) =>
                      `sidebar-link sidebar-title link-nav${isActive ? " active" : ""}`
                    }
                    onClick={() => toggleNavActive(menuItem)}
                  >
                    {IconComponent && (
                      <IconComponent
                        size={18}
                        strokeWidth={1.75}
                        className="sidebar-feather-icon"
                        aria-hidden
                      />
                    )}
                    <span>{t(menuItem.title)}</span>
                    {menuItem.badge && (
                      <label className={menuItem.badge}>
                        {menuItem.badgetxt}
                      </label>
                    )}
                  </NavLink>
                )}

                {/* ── Children (sub-menu items) ── */}
                {menuItem.children && (
                  <ul
                    className="sidebar-submenu"
                    style={
                      layout1 !== "compact-sidebar compact-small"
                        ? menuItem.active || isItemActive
                          ? sidebartoogle
                            ? {
                                opacity: 1,
                                transition: "opacity 500ms ease-in",
                              }
                            : { display: "block" }
                          : { display: "none" }
                        : { display: "none" }
                    }
                  >
                    {menuItem.children.map((child, childIdx) => {
                      const isChildActive =
                        child.active ||
                        (child.path &&
                          location.pathname.startsWith(
                            child.path.replace(
                              process.env.PUBLIC_URL || "",
                              "",
                            ),
                          ));

                      return (
                        <li key={childIdx}>
                          {/* Level-2 sub */}
                          {child.type === "sub" && (
                            <a
                              href="#!"
                              className={isChildActive ? "active" : ""}
                              onClick={(e) => {
                                e.preventDefault();
                                toggleNavActive(child);
                              }}
                            >
                              {t(child.title)}
                              <span className="sub-arrow">
                                <i className="fa fa-chevron-right" />
                              </span>
                              <div className="according-menu">
                                <i
                                  className={`fa fa-angle-${child.active ? "down" : "right"}`}
                                />
                              </div>
                            </a>
                          )}

                          {/* Level-2 link */}
                          {child.type === "link" && (
                            <NavLink
                              to={child.path}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                              onClick={() => toggleNavActive(child)}
                            >
                              {t(child.title)}
                            </NavLink>
                          )}

                          {/* Level-3 grandchildren */}
                          {child.children && (
                            <ul
                              className="nav-sub-childmenu submenu-content"
                              style={
                                isChildActive || child.active
                                  ? { display: "block" }
                                  : { display: "none" }
                              }
                            >
                              {child.children.map((grandchild, gcIdx) => (
                                <li key={gcIdx}>
                                  {grandchild.type === "link" && (
                                    <NavLink
                                      to={grandchild.path}
                                      className={({ isActive }) =>
                                        isActive ? "active" : ""
                                      }
                                      onClick={() =>
                                        toggleNavActive(grandchild)
                                      }
                                    >
                                      {t(grandchild.title)}
                                    </NavLink>
                                  )}
                                </li>
                              ))}
                            </ul>
                          )}
                        </li>
                      );
                    })}
                  </ul>
                )}
              </li>
            );
          })}
        </Fragment>
      ))}
    </>
  );
};

export default SidebarMenuItems;
